import apiUrl from '../../../constants'
import axios from 'axios'
import PageTracker from '../../../common/PageTrackerHelper';
import CryptoJS from 'crypto-js';
import VueElementLoading from 'vue-element-loading';
import moment from 'moment';
import {Validator} from 'vee-validate'

export default {
    name: 'DeliveryOTPs',
    components: {
        VueElementLoading
    },
    mixins:[PageTracker],
    data: function() {
        return {
            DeliveryOTP:[],
            ShippingId:'',
            awbArray1:[],
            isShipmentLoader:false,
            userDataKey : '',
        }
     },
async mounted(){
  this.userDataKey = window.localStorage.getItem('userUniqueKey');
  let validateUser = await this.validateJwtToken();
  var userdetailEncrypt = window.localStorage.getItem('lmaccessuserdata')
  var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), this.userDataKey);
  var plaintext = bytes.toString(CryptoJS.enc.Utf8);
  var userdetail = JSON.parse(plaintext)
  this.userHubId = userdetail.hubdetails[0] == undefined ? 0 : userdetail.hubdetails[0]
  this.createdBy = userdetail.username;
  this.userid = userdetail.userid;
},
methods : {
    validateForm1(scope) {
        this.$validator.validateAll(scope).then(result => {
          if (result) {
            this.isShipmentLoader = true;
            this.awbArray1 = [];
            //non rvp shipments handover logic start here.
            let shippingidsWithNextLine = this.ShippingId.split("\n").map(String);
            let shippingidsWithComma = this.ShippingId.split(",").map(String);
            if(shippingidsWithNextLine.length > 1) {

              $.each(shippingidsWithNextLine, (key,sid)=>{
                if(sid != null && sid !=''){
                  this.awbArray1.push(sid.trim());
                }
              })
            } else if(shippingidsWithComma.length >= 1){

              $.each(shippingidsWithComma, (key,sid)=>{
                if(sid != null && sid !=''){
                  this.awbArray1.push(sid.trim());
                }
              })
            }
            axios.post(apiUrl.api_url + 'websupport/getDeliveryotps/byshippingids', {ShippingID:this.awbArray1})
            .then((response) => {
                if(response.data.code===200){
                  // console.log(response.data);
                  this.DeliveryOTP=response.data.data;
                }
                else {
                    this.DeliveryOTP=[];
                    this.$alertify.error('No Shipments found')
                }
                this.isShipmentLoader=false;
            })
            .catch((httpException) => {
                  this.$alertify.error("Shipment data not found");
                  console.error('exception is:::::::::', httpException)
                  this.isShipmentLoader=false;
            })
          }
          })
      },

      resetForm1(){
        this.DeliveryOTP = '',
        this.ShippingId = '',
        this.$validator.reset();
        this.errors.clear();
         }
      }
    }



// WEBPACK FOOTER //
// ./src/views/components/DeliveryOTPs/DeliveryOTP.component.js